import { ResponsiveContext } from 'grommet';
import { Project } from 'lib/api';
import { observer } from 'mobx-react-lite';
import { useContext } from 'react';
import { shortenCurrency, USD } from 'src/utils/currency';
import { AddNewButton } from '../AddNewButton';
import { SaveStatus } from '../SaveStatusIndicator';
import { HeaderTotal, PageHeader } from '../PageHeader';

export type SessionEstimatorHeaderProps = {
  project: Project;
  onCreate: () => Promise<void>;
  saveStatus?: SaveStatus;
  totalWages?: number;
  grandTotal?: number;
};

export const SessionEstimatorHeader = observer(
  ({ project, onCreate, saveStatus, totalWages, grandTotal }: SessionEstimatorHeaderProps) => {
    /** Context **/
    const screenSize = useContext(ResponsiveContext);

    /** Computed **/
    const isDesktop = screenSize === 'large';

    /** Render **/
    return (
      <PageHeader
        title={`${project.name} Sessions`}
        saveStatus={saveStatus}
        actions={<AddNewButton onClick={onCreate} label="New session" />}
        totals={
          <>
            <HeaderTotal label="Total wages" value={(!isDesktop ? shortenCurrency : USD)(totalWages)} />
            <HeaderTotal label="Grand total" value={(!isDesktop ? shortenCurrency : USD)(grandTotal)} grand />
          </>
        }
      />
    );
  }
);
